<template lang="pug">
  v-layout(align-start)
    v-col
      v-flex(flex-grow-1)
        v-app-bar(dark color='primary')
          v-toolbar-title.head-ajuste ACTUALIZACIÓN DE INVENTARIO
        v-card
          v-row.mb-5
            v-col.d-flex.justify-center
              v-btn(color='primary', small, dark, @click='dialog = true' height='2rem')
                v-icon mdi-plus
                | Hacer nuevo ajuste

          v-flex(d-flex flex-wrap justify-space-between mb-5 px-2)
            v-flex(xs12 sm3 md3)
              v-select(v-model="selectedDate" dense outlined :items="seleccionarFecha" label="Selecionar Rango" @change='changeFecha')
            v-flex(xs12 sm3 md3)
              v-dialog(ref='dialog1' v-model='modalDate1' :return-value.sync='date' readonly persistent width='300px')
                template(v-slot:activator='{ on }')
                  v-text-field( v-model='fechaDesde' label='Desde' prepend-icon='event' readonly dense outlined v-on='on' :max='date')
                v-date-picker(:max='date' v-model='fechaDesde' locale="ES" )
                  v-spacer
                  v-btn(small dark color='red' @click='modalDate1 = false') Cancelar
                  v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
            v-flex(xs12 sm3 md3)
              v-dialog(ref='dialog2' v-model='modalDate2' :return-value.sync='date' readonly persistent width='300px')
                template(v-slot:activator='{ on }')
                  v-text-field( v-model='fechaHasta' label='Hasta' prepend-icon='event' readonly dense outlined v-on='on' :max='date')
                v-date-picker(:max='date' v-model='fechaHasta' locale="ES")
                  v-spacer
                  v-btn(small dark color='red' @click='modalDate2 = false') Cancelar
                  v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
            v-flex(xs12 sm2 md2)
              v-btn(@click='buscarAjustes' color='primary' dark width="100%") PROCESAR

      v-flex(flex-grow-1)
        v-data-table.elevation-1(
          :headers='headerListado',
          :items='listadoAjustado',
          hide-default-footer,
          :items-per-page='-1',
          no-data-text='NO HAY PRODUCTOS PARA MOSTRAR'
        )
          template(v-slot:top)
            v-toolbar(flat color='primary' dark)
              v-flex(class="d-flex flex-wrap justify-center")
                v-toolbar-title Ajustes Realizados
          template(v-slot:item.action='{ item }')
            v-tooltip(bottom)
              template(v-slot:activator='{ on }')
                v-icon.mr-2(color='primary_2' @click='verDetalles(item)' v-on="on") mdi-eye
              | Detallet

      v-dialog(v-model='dialogDetalles' max-width='80%')
        v-card(color='grey_1')
          v-app-bar(dark color='primary')
            span.headline Detalle Ajuste
          v-card-text
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Fecha
                  v-card-text
                    v-row(dense)
                      v-col(cols='12', xs='12', sm='6')
                        v-text-field(readonly, dense, outlined, v-model='detalles._id' label='Fecha')
                      v-col(cols='12', xs='12', sm='6')
                        v-text-field(readonly, dense, outlined, v-model='detalles.cantidadTotal' label='cantidad Total de Producto')
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Detalles de los Productos
                  v-card-text
                    v-row(dense)
                      v-col
                        v-data-table.elevation-1(
                          :headers='headerDetalle',
                          :items='detalles.productos',
                          hide-default-footer,
                          :items-per-page='-1',
                          no-data-text='NO HAY PRODUCTOS'
                          width='100%'
                        )

      v-dialog(v-model='dialog' persistent max-width='80%')
        v-card(color='grey_1')
          v-app-bar(dark color='primary')
            span.headline Nuevo Ajuste
          v-card-text
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Buscar Producto
                  v-card-text
                    v-row(dense)
                      v-col(cols='12', sm='8')
                        v-autocomplete(:disabled='editedId !== null' autocomplete="off", dense, outlined, v-model='editedItem.idProducto' :items='productos', label='Buscar Producto')
                      v-col(cols='12', sm='4')
                        v-text-field(dense, outlined, v-model.number='editedItem.cantidad' label='cantidad', type='number')
                    v-row(dense)
                      v-textarea(dense, outlined, v-model='editedItem.observacion', label='observacion', rows='3')

                    v-row(dense, justify='end')
                      v-btn(v-if='editedId' color='error', small, dark, @click='cancelarEditar' style='margin-right: 0.3rem')
                        v-icon mdi-plus
                        | Cancelar
                      v-btn(v-if='!editedId' color='success', small, dark, @click='agregarProducto')
                        v-icon mdi-plus
                        | Agregar
                      v-btn(v-else color='success', small, dark, @click='editarProducto(null, "aprobado")')
                        v-icon mdi-plus
                        | Editar
            v-row(dense)
              v-col(cols='12')
                v-card(color='white')
                  v-card-subtitle.title(style='color: black') Productos a Ajustar
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-data-table(
                          :headers='headers',
                          :items='productosAjustados',
                          hide-default-footer,
                          :items-per-page='-1',
                          no-data-text='NO HAY PRODUCTOS'
                        )
                          template(v-slot:item.action='{ item }')
                            v-tooltip(v-if='editedId !== item.idProducto._id' bottom)
                              template(v-slot:activator='{ on }')
                                v-icon.mr-2( color='warning', @click='editarProducto(item, "editar")', v-on="on") mdi-pencil
                              | Editar
                            v-tooltip(bottom)
                              template(v-slot:activator='{ on }')
                                v-icon(color='error', @click='quitarProducto(item)', v-on="on") mdi-delete
                              | Eliminar
          v-card-actions
            v-spacer
            v-btn(color='error' small dark @click='close')
              v-icon mdi-close
              | Cancelar
            v-btn(color='success' small dark @click='save')
              v-icon mdi-content-save
              | Guardar
</template>

<script>
import Api from '@/services/methods'
// import { arrayMayusculas } from '../helpers/index'
export default {
  data: () => ({
    search: '',
    dialog: false,
    dialogDetalles: false,
    loading: true,
    editedId: null,
    pagination: {},
    headers: [
      {
        text: 'Producto',
        align: 'start',
        sortable: false,
        value: 'idProducto.descripcion'
      },
      { text: 'Cantidad', value: 'cantidad', align: 'start' },
      {
        text: 'Observacion',
        value: 'observacion',
        sortable: false,
        align: 'center'
      },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headerListado: [
      { text: 'Fecha', value: '_id' },
      { text: 'CantidadTotal', sortable: false, value: 'cantidadTotal' },
      { text: 'Detalles', value: 'action', align: 'right', sortable: false }
    ],
    headerDetalle: [
      { text: 'Codigo', value: 'codigoProducto' },
      { text: 'Nombre', value: 'nombreProducto' },
      { text: 'Cant. Ajustado', value: 'cantidad' },
      { text: 'Observacion', value: 'observacion' }
    ],
    listadoAjustado: [],
    dialog1: false,
    dialog2: false,
    modalDate1: false,
    modalDate2: false,
    date: new Date().toISOString().substr(0, 10),
    fechaDesde: '',
    fechaHasta: '',
    selectedDate: 0,
    seleccionarFecha: [
      {
        text: 'Hoy',
        value: 1
      },
      {
        text: 'Ayer',
        value: 2
      },
      {
        text: 'Últimos 7 días',
        value: 3
      },
      {
        text: 'Últimos 30 días',
        value: 4
      },
      {
        text: 'Fecha Personalizada',
        value: 5
      }
    ],
    productos: [],
    productosAjustados: [],
    detalles: {},
    indexDetalles: -1,
    editedItem: {
      idProducto: '',
      cantidad: 0,
      observacion: '',
      indexListado: null
    },
    defaultItem: {
      idProducto: '',
      cantidad: 0,
      observacion: '',
      indexListado: null
    }
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarProductos()
    },

    changeFecha () {
      let hoy = this.$moment(this.date)
      switch (this.selectedDate) {
        case 1:
          this.fechaDesde = hoy.format('YYYY-MM-DD')
          this.fechaHasta = hoy.format('YYYY-MM-DD')
          this.buscarAjustes()
          break
        case 2:
          this.fechaDesde = hoy.subtract(1, 'd').format('YYYY-MM-DD')
          this.fechaHasta = this.fechaDesde
          this.buscarAjustes()
          break
        case 3:
          this.fechaHasta = hoy.format('YYYY-MM-DD')
          this.fechaDesde = hoy.subtract(7, 'd').format('YYYY-MM-DD')
          this.buscarAjustes()
          break
        case 4:
          this.fechaHasta = hoy.format('YYYY-MM-DD')
          this.fechaDesde = hoy.subtract(30, 'd').format('YYYY-MM-DD')
          let fecha2 = hoy.subtract(30, 'd')
          let prueba = fecha2.diff(hoy, 'days')
          this.buscarAjustes()
          break
        case 5:
          this.fechaHasta = ''
          this.fechaDesde = ''
          break
      }
    },

    editItem (item) {
      this.editedIndex = this.productos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.nuevaCantidad = 0
      this.dialog = true
    },

    verDetalles (item) {
      this.indexDetalles = this.listadoAjustado.indexOf(item)
      this.detalles = Object.assign({}, item)
      this.dialogDetalles = true
    },

    listarProductos () {
      Api.get('/producto')
        .then(response => {
          response.data.forEach(producto => {
            this.productos.push({
              value: {
                _id: producto._id,
                nombre: producto.nombre,
                descripcion: producto.descripcion
              },
              text: `${producto.nombre} ${producto.descripcion}`
            })
          })

          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar los datos'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    agregarProducto () {
      if (!this.validate()) {
        const index = this.productos.findIndex(
          producto => producto.value._id === this.editedItem.idProducto._id
        )
        this.editedItem.indexListado = index
        this.productosAjustados.push({ ...this.editedItem })
        this.productos.splice(index, 1)
        this.editedItem = Object.assign({}, this.defaultItem)
      }
    },

    quitarProducto (item) {
      const index = this.productosAjustados.findIndex(
        producto => producto._id === item.idProducto._id
      )
      this.productosAjustados.splice(index, 1)
      if (this.editedId === item.idProducto._id) {
        this.editedId = null
        this.editedItem = Object.assign({}, this.defaultItem)
      } else {
        this.productos.splice(item.indexListado, 0, {
          value: {
            _id: item.idProducto._id,
            nombre: item.idProducto.nombre,
            descripcion: item.idProducto.descripcion
          },
          text: `${item.idProducto.nombre} ${item.idProducto.descripcion}`
        })
      }
    },

    editarProducto (item, accion) {
      if (accion === 'editar') {
        this.editedItem = { ...item }
        this.editedId = item.idProducto._id
        const index = this.productosAjustados.findIndex(
          producto => producto._id === item.idProducto._id
        )
        this.productos.splice(item.indexListado, 0, {
          value: {
            _id: item.idProducto._id,
            nombre: item.idProducto.nombre,
            descripcion: item.idProducto.descripcion
          },
          text: `${item.idProducto.nombre} ${item.idProducto.descripcion}`
        })
      } else {
        if (!this.validate()) {
          const index = this.productosAjustados.findIndex(
            producto =>
              producto.idProducto._id === this.editedItem.idProducto._id
          )
          this.productosAjustados.splice(index, 1, this.editedItem)
          this.productos.splice(this.editedItem.indexListado, 1)
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedId = null
        }
      }
    },

    cancelarEditar () {
      this.productos.splice(this.editedItem.indexListado, 1)
      this.editedId = null
      this.editedItem = Object.assign({}, this.defaultItem)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.productosAjustados = []
        this.editedId = null
      }, 300)
    },

    validate () {
      if (
        this.editedItem.cantidad <= 0 ||
        this.editedItem.cantidad === '' ||
        !this.editedItem.cantidad
      ) {
        this.$swal({
          icon: 'error',
          title: 'Cantidad incorrecta',
          text: 'Por favor introduza una cantidad correcta para guardar'
        })
        return true
      }
      if (
        !this.editedItem.observacion ||
        this.editedItem.observacion.trim() === '' ||
        !this.editedItem.idProducto?._id
      ) {
        this.$swal({
          icon: 'error',
          title: 'Fomurlario incompleto',
          text: 'el producto y las descripcion son obligatorias'
        })
        return true
      }
      return false
    },

    validarFecha () {
      let desde = this.$moment(this.fechaDesde)
      let hasta = this.$moment(this.fechaHasta)
      const rango = hasta.diff(desde, 'days')
      if (rango < 0) {
        this.$swal({
          icon: 'error',
          title: 'Error al escoger el rango de las fechas',
          text: 'La fecha de inicio no puede ser mayor a la fecha final'
        })
        return true
      }
      return false
    },

    buscarAjustes () {
      this.listadoAjustado = []
      this.loading = true
      let fecha1 = this.$moment(this.fechaDesde)
      let fecha2 = this.$moment(this.fechaHasta)
      if (!this.validarFecha()) {
        Api.get(
          `proAlma/productosAjustados/${this.fechaDesde}/${this.fechaHasta}`
        )
          .then(res => {
            this.listadoAjustado = res.data
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    },

    save () {
      if (true) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        Api.put('proalma/ajuste', this.productosAjustados)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            // this.editedItem.cantidad += this.editedItem.nuevaCantidad
            // Object.assign(this.productos[this.editedIndex], this.editedItem)
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
}
</script>
<style lang="scss">
.head-ajuste {
  font-size: 1.5rem;
}
@media screen and (max-width: 425px) {
  .head-ajuste {
    font-size: 1rem;
  }
}
</style>
